import http from "@/api";

export const register = (params: API.RegisterCmd) => {
	return http.post<API.Response<API.SingleResult<API.Member>>>(`/register`, params);
};

export const getMember = () => {
	return http.get<API.Response<API.SingleResult<API.Member>>>(`/members`);
};

export const getAccount = () => {
	return http.get<API.Response<API.SingleResult<API.Account>>>(`/accounts`);
};

export const sumAwardAmount = (params: any) => {
	return http.get<API.Response<API.SingleResult<number>>>(`/accounts/award/amount/sum`, params);
};

export const getAccountStatistic = () => {
	return http.get<API.Response<API.SingleResult<API.Statistic>>>(`/accounts/statistic`);
};

export const getAccountDateStatistic = (params: any) => {
	return http.get<API.Response<API.PageResult<API.Statistic["dateStatistic"]>>>(`/accounts/dateStatistic`, params);
};

export const pageRechargeRecords = (params: any) => {
	return http.get<API.Response<API.PageResult<API.RechargeRecord>>>(`/accounts/rechargeRecords/page`, params);
};

export const withdrawal = (params: API.WithdrawalCmd) => {
	return http.post<API.Response<API.SingleResult<string>>>(`/accounts/withdrawal`, params);
};

export const pageWithdrawalRecords = (params: any) => {
	return http.get<API.Response<API.PageResult<API.WithdrawalRecord>>>(`/accounts/withdrawalRecords/page`, params);
};

export const validTradingPassword = (params: { tradingPassword: string }) => {
	return http.post<API.Response<API.SingleResult<string>>>(`/withdrawalAccounts/validTradingPassword`, params);
};

export const updatePassword = (params: API.PasswordUpdateCmd) => {
	return http.put<API.Response<API.SingleResult<boolean>>>(`/members/password`, params);
};

export const updateTradingPassword = (params: API.PasswordUpdateCmd) => {
	return http.put<API.Response<API.SingleResult<boolean>>>(`/accounts/tradingPassword`, params);
};

export const updateAvatar = (params: { avatar: string }) => {
	return http.put<API.Response<API.SingleResult<boolean>>>(`/members/avatar`, params);
};

export const lisWithdrawalAccounts = (params: any) => {
	return http.get<API.Response<API.ListResult<API.WithdrawalAccount>>>(`/withdrawalAccounts/list`, params);
};

export const getWithdrawalAccount = (token: string, id: string) => {
	return http.get<API.Response<API.SingleResult<API.WithdrawalAccount>>>(`/withdrawalAccounts/${id}?token=${token}`);
};

export const createWithdrawalAccount = (token: string, params: API.WithdrawalAccountCreateCmd) => {
	return http.post<API.Response<API.SingleResult<API.WithdrawalAccount>>>(`/withdrawalAccounts?token=${token}`, params);
};

export const updateWithdrawalAccount = (token: string, id: string, params: API.WithdrawalAccountUpdateCmd) => {
	return http.put<API.Response<API.SingleResult<API.WithdrawalAccount>>>(
		`/withdrawalAccounts/${id}?token=${token}`,
		params
	);
};

export const deleteWithdrawalAccount = (token: string, id: string) => {
	return http.delete<API.Response<API.SingleResult<string>>>(`/withdrawalAccounts/${id}?token=${token}`);
};

export const verifyWithdrawalAccountsHash = (id: string, params: API.WithdrawalVerifyParams) => {
	return http.put<API.Response<API.SingleResult<string>>>(`/withdrawalAccounts/verify/${id}`, params);
};
export const getAccountsTicket = () => {
	return http.get<API.Response<API.SingleResult<string>>>(`/accounts/ticket`);
};

export const postAccountsLoginSignIn = () => {
	return http.post<API.Response<API.SingleResult<0 | 1>>>(`/accounts/loginSignIn`);
};

export const accountsCompleteTaskSignIn = () => {
	return http.post<API.Response<API.SingleResult<0 | 1>>>(`/accounts/completeTaskSignIn`);
};
